import moment from 'moment';

import type { Moment } from 'moment/moment';

export type DatePickerWithPresetsOptionsType = {
  label: string;
  value: string;
  check: (startDate: Moment, endDate: Moment) => boolean;
};
export const datePickerWithPresetsOptions: DatePickerWithPresetsOptionsType[] = [
  { label: 'Custom', value: 'custom', check: () => false },
  {
    label: 'Today',
    value: 'today',
    check: (startDate, endDate) =>
      startDate.isSame(moment().startOf('day')) && endDate.isSame(moment().endOf('day')),
  },
  {
    label: 'Yesterday',
    value: 'yesterday',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(1, 'day').startOf('day')) &&
      endDate.isSame(moment().subtract(1, 'day').endOf('day')),
  },
  {
    label: 'Last 7 days',
    value: 'last-7-days',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(6, 'days').startOf('day')) && endDate.isSame(moment().endOf('day')),
  },
  {
    label: 'Last 14 days',
    value: 'last-14-days',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(13, 'days').startOf('day')) && endDate.isSame(moment().endOf('day')),
  },
  {
    label: 'This month',
    value: 'this-month',
    check: (startDate, endDate) =>
      startDate.isSame(moment().startOf('month').startOf('day')) &&
      endDate.isSame(moment().endOf('month').endOf('day')),
  },
  {
    label: 'Last month',
    value: 'last-month',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(1, 'month').startOf('month').startOf('day')) &&
      endDate.isSame(moment().subtract(1, 'month').endOf('month').endOf('day')),
  },
  {
    label: 'Last 3 months',
    value: 'last-3-months',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(2, 'months').startOf('month').startOf('day')) &&
      endDate.isSame(moment().endOf('month').endOf('day')),
  },
  {
    label: 'Last 6 months',
    value: 'last-6-months',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(5, 'months').startOf('month').startOf('day')) &&
      endDate.isSame(moment().endOf('month').endOf('day')),
  },
  {
    label: 'This year',
    value: 'this-year',
    check: (startDate, endDate) =>
      startDate.isSame(moment().startOf('year').startOf('day')) &&
      endDate.isSame(moment().endOf('year').endOf('day')),
  },
  {
    label: 'Last year',
    value: 'last-year',
    check: (startDate, endDate) =>
      startDate.isSame(moment().subtract(1, 'year').startOf('year').startOf('day')) &&
      endDate.isSame(moment().subtract(1, 'year').endOf('year').endOf('day')),
  },
];
